import { Inventory2 } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { M_Fieldset } from 'src/M_Components'
import { CommodityFormField } from './CommodityFormField'

export const CommodityDetails = ({ dataState, setDataState }) => {
    const { t } = useTranslation()

    const formFields = [
        { display: t('CommodityCode'), required: true, code: 'CommodityCode', type: 'text' },
        { display: t('CommodityName'), required: true, code: 'CommodityName', type: 'text' },
        { display: t('CommodityDescription'), required: false, code: 'CommodityDescription', type: 'text' },
    ]

    return (
        <M_Fieldset
            labelInside
            label={
                <div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}>
                    <Inventory2 style={{ marginRight: '10px', scale: '1.3' }} />
                    {t('CommodityDetails')}
                </div>
            }
            elements={
                <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%' }}>
                    {formFields.map((field, index) => (
                        <CommodityFormField key={index} fields={field} data={dataState} setData={setDataState} />
                    ))}
                </div>
            }
        />
    )
}
